import React from "react";
import "../styles.scss";
import FormSwitch from "../../shared/form-switch";

export let navigate = {
  PREVIOUS: "PREV",
  NEXT: "NEXT",
  TODAY: "TODAY",
  DATE: "DATE",
};

const CustomToolbar = ({
  booking,
  onNavigate,
  label,
  onChangePageMode,
  pageShowIsBar,
  isGroumet,
}) => {
  const [isActive, setIsActive] = React.useState(pageShowIsBar);
  React.useEffect(() => {
    if (booking.simpleCalendarChosenDate) {
      onNavigate(navigate.DATE, booking.simpleCalendarChosenDate);
    }
  }, [booking.simpleCalendarChosenDate, onNavigate]);

  const handleNavigate = (action) => {
    onNavigate(action);
  };

  const handleChange = (value) => {
    setIsActive(value);
    onChangePageMode(value);
  };

  return (
    <div className="rbc-toolbar custom position-relative">
      {isGroumet && (
        <div className="position-absolute switch-bar-mode">
          <div className="d-flex align-items-center gap-2">
            <FormSwitch onChange={handleChange} checkedValue={isActive} />
            <p>バーの予約に切り替える</p>
          </div>
        </div>
      )}

      <div className="navigate-wrapper">
        <div className="rbc-toolbar-label me-2">{label}</div>
        <div className="rbc-navigate-wrapper">
          <span className="rbc-btn-group custom">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 0 24 24"
              width="24px"
              fill="#000000"
              onClick={() => handleNavigate(navigate.PREVIOUS)}
            >
              <path d="M0 0h24v24H0V0z" fill="none" opacity=".87" />
              <path d="M17.51 3.87L15.73 2.1 5.84 12l9.9 9.9 1.77-1.77L9.38 12l8.13-8.13z" />
            </svg>
          </span>
          <span className="rbc-btn-group custom me-1">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              enableBackground="new 0 0 24 24"
              height="24px"
              viewBox="0 0 24 24"
              width="24px"
              fill="#000000"
              onClick={() => handleNavigate(navigate.NEXT)}
            >
              <g>
                <path d="M0,0h24v24H0V0z" fill="none" />
              </g>
              <g>
                <polygon points="6.23,20.23 8,22 18,12 8,2 6.23,3.77 14.46,12" />
              </g>
            </svg>
          </span>
          <span
            className="today-btn"
            onClick={() => handleNavigate(navigate.TODAY)}
          >
            今日
          </span>
        </div>
      </div>
    </div>
  );
};

export default CustomToolbar;
